import axios from 'axios'

export const systemConfig = {
  configurationPath: process.env.REACT_APP_API_URL + '/api/configuration'
}

export const getSystemConfig = () => {
  var conf = JSON.parse(localStorage.getItem('configuration'))
  return conf
}

export const setSystemConfig = () => {
  var url = systemConfig.configurationPath
  return axios
    .get(url)
    .then(({ data }) => {
      if (data.isError) {
        console.error(data.message)
      } else {
        localStorage.setItem('configuration', JSON.stringify(data.data))
      }
      return data
    })
    .catch(function (error) {
      console.error(error)
    })
}
